




























import { dayjs, DW_FORMAT_JA, D_FORMAT_JA, T_FORMAT, T_FORMAT_JA } from '../../../../src_server/common/momentExtends';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
// eslint-disable-next-line @typescript-eslint/no-var-requires
import VueTimepicker from 'vue2-timepicker';
import { ShiftTable } from '../../../../src_server/entity/generated/ShiftTable';
import { Dayjs } from 'dayjs';
import { LessonScheduleDTO } from '../../../../src_server/entity/dto/LessonScheduleDTO';
import SimpleCheckBox from '../../../components/inputs/SimpleCheckBox.vue';
import { LessonStates } from '../../../../src_server/entity/master/LessonStates';
import { MessageDialog } from '../../../utils/MessageDialog';
import { LessonConst } from '../../../../src_server/entity/master/LessonConst';
import { Session } from '../../../utils/Session';
@Component({
  components: { VueTimepicker, SimpleCheckBox },
  filters: {
    dateFormat: (dt: Date) => {
      return dayjs(dt).format(DW_FORMAT_JA);
    },
    timeFormat: (dt: Date) => {
      return dayjs(dt).format(T_FORMAT_JA);
    },
  },
})
export default class ScheduleHourSetting extends Vue {
  @Prop()
  value!: LessonScheduleDTO;

  @Prop({ default: false })
  selectedInit!: boolean;

  private result: {
    selected: boolean;
    hasError: boolean;
    overWriteShift: ShiftTable;
  } = {
    selected: false,
    hasError: false,
    overWriteShift: new ShiftTable(),
  };

  get defaultStartTime() {
    return dayjs(this.value.shiftTable?.start_time).format(T_FORMAT);
  }
  get defaultEndTime() {
    return dayjs(this.value.shiftTable?.end_time).format(T_FORMAT);
  }

  get title() {
    // const dateString = dayjs(this.value.shiftTable?.start_time).format(DW_FORMAT_JA);
    // return `${dateString}を選択`;
    return '';
  }

  get hasResevation() {
    const isInclued = [LessonStates.RESERVATION, LessonStates.COMMIT, LessonStates.ALREADY, LessonStates.TRANSFAR, LessonStates.DELETED].includes(this.value.lesson?.reservation_state || '');
    return isInclued;
  }

  get state() {
    if (!this.value.lesson?.reservation_state) {
      return '';
    }
    const who = this.value.lesson.student_user_id === Session.getSessionUserId() ? 'あなたの' : 'ほかの人の';
    return `${who}${this.value.lesson.reservation_state}が入っています`;
  }

  get css() {
    return { 'alert-danger': this.result.hasError };
  }

  /**
   * 入力されたShiftTableを複製しておく
   */
  @Watch('value', { immediate: true })
  initResult() {
    const clone = JSON.stringify(this.value.shiftTable);
    this.result.overWriteShift = JSON.parse(clone);
  }

  /**
   * 選択変更をした時に結果を呼び出し元に返す
   */
  @Watch('result.selected', { immediate: true })
  emitResult() {
    // console.log('result ', this.result);
    this.$emit('select', this.result);
  }

  mounted() {
    if (this.state === '') {
      this.result.selected = this.selectedInit;
    }
  }

  /**
   * 開始時間を書き換えるイベントハンドラ
   */
  async startChange(event: any) {
    if (!event) {
      return;
    }

    const result = this.hasTimeRangeError(this.value.shiftTable?.start_time, this.value.shiftTable?.end_time, event);
    this.result.hasError = result.has;
    if (result.has) {
      await MessageDialog.alert(result.message);
      // RESTでチェックするためにブロックせずにスルー
      // ここで止めてしまうと、デフォルトの範囲時間でリクエストされてしまう
    }

    // 開始時間を結果オブジェクトにセット
    this.result.overWriteShift.start_time = this.timeSet(dayjs(this.value.shiftTable?.start_time), event.data);
    this.result.overWriteShift.end_time = dayjs(this.result.overWriteShift.start_time).add(LessonConst.LESSON_TIME, 'minute').toDate();
  }

  /**
   * 終了時間を書き換えるイベントハンドラ
   */
  async endChange(event: any) {
    if (!event) {
      return;
    }
    const result = this.hasTimeRangeError(this.value.shiftTable?.start_time, this.value.shiftTable?.end_time, event);
    this.result.hasError = result.has;
    if (result.has) {
      await MessageDialog.alert(result.message);
    }

    // 終了時間を結果オブジェクトにセット
    this.result.overWriteShift.end_time = this.timeSet(dayjs(this.value.shiftTable?.end_time), event.data);
  }

  /**
   * 時間の範囲をチェック
   */
  hasTimeRangeError(start_dt: Date | undefined, end_dt: Date | undefined, event: any): { has: boolean; message: string } {
    const start = dayjs(this.value.shiftTable?.start_time);
    const end = dayjs(this.value.shiftTable?.end_time);
    if (this.compareDate(start, event.data) > 0) {
      return { has: true, message: '開始時間が可能時間より前の時間です' };
    }
    if (this.compareDate(end, event.data) < 0) {
      return { has: true, message: '開始時間が可能時間より後の時間です' };
    }
    return { has: false, message: '' };
  }

  // 時間を書き変える共通処理
  timeSet(origin: Dayjs, data: { HH: number; mm: number }): Date {
    const time = origin.set('hour', data.HH).set('minute', data.mm);
    console.log('time.todate', time.toDate());
    return time.toDate();
  }

  compareDate(origin: Dayjs, data: { HH: number; mm: number }): number {
    const compareDj = dayjs(origin).set('hour', data.HH).set('minute', data.mm);
    return origin.diff(compareDj, 'minute');
  }
}
